module.exports = __webpack_public_path__ + "img/banner.6b737528.png";